export default {
    user:                   state => state.user,
    objects:                state => state.objects,
    tinyObjects:            state => state.tinyObjects,
    object_packets:         state => state.object_packets,
    editObject:             state => state.editObject,
    numOfPages:             state => state.numOfPages,
    numOfPagesForRequests:  state => state.numOfPagesForRequests,
    locales:                state => state.locales,
    impressum:              state => state.impressum,
    availableFilters:       state => state.availableFilters,
    loading:                state => state.loading,
    notifications_count:    state => state.notifications_count,
    assessment_count:       state => state.assessment_count,
    queries:                state => state.queries,
    overview:               state => state.overview,
    sepaInfoMissing:        state => state.sepaInfoMissing,
    sepaDetails:            state => state.sepaDetails,
}
